module.exports = __webpack_public_path__ + "img/home_bg.597ede59.svg";